import axios from "../../config/axios";

export const getAllStaff = () => axios.get("staff/users/user-type/2");



// WEBPACK FOOTER //
// ./src/services/requestors/staff.js